import { useEffect, useRef } from "react";
import { IoClose } from "react-icons/io5";
import { FaPaperPlane, FaWhatsapp } from "react-icons/fa";
import { useBelaChat } from "./BelaChatContext";
import "./BelaChatPanel.css";

/**
 * Chat drawer patterned on belpower-frontend ChatBotPopup —
 * replies route users to Belsoft WhatsApp support.
 */
export default function BelaChatPanel() {
  const {
    isOpen,
    messages,
    input,
    isTyping,
    whatsappUrl,
    setInput,
    closeChatBot,
    sendMessage,
  } = useBelaChat();
  const chatEndRef = useRef(null);

  useEffect(() => {
    if (!isOpen) return;
    const onKeyDown = (e) => {
      if (e.key === "Escape") closeChatBot();
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [isOpen, closeChatBot]);

  useEffect(() => {
    chatEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages, isTyping, isOpen]);

  if (!isOpen) return null;

  return (
    <>
      <button
        type="button"
        className="bela-chatbot-backdrop"
        aria-label="Close chat"
        onClick={closeChatBot}
      />
      <div
        className="bela-chatbot-container"
        role="dialog"
        aria-modal="true"
        aria-label="Chat with Bela"
      >
        <div className="bela-chatbot-header">
          <button
            type="button"
            className="bela-chatbot-close"
            onClick={closeChatBot}
            title="Close Chat"
            aria-label="Close Chat"
          >
            <IoClose size={24} />
          </button>
          <div className="bela-chatbot-header-inner">
            <div className="bela-chatbot-avatar-lg">
              <img src="/Bela.png" alt="Bela" width={112} height={112} />
            </div>
            <h2>Bela</h2>
            <p>AI Assistant</p>
            <div className="bela-chatbot-divider" />
          </div>
        </div>

        <div className="bela-chatbot-body">
          {messages.map((msg) => (
            <div
              key={msg.id}
              className={`bela-msg-row ${msg.sender === "user" ? "user" : "bot"}`}
            >
              {msg.sender === "bot" && (
                <div className="bela-msg-avatar">
                  <img src="/Bela.png" alt="" width={32} height={32} />
                </div>
              )}
              <div
                className={`bela-msg-bubble ${
                  msg.sender === "user" ? "user" : "bot"
                }`}
              >
                <div>{msg.content}</div>
                {msg.showWhatsApp && (
                  <a
                    href={whatsappUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="bela-whatsapp-btn"
                  >
                    <FaWhatsapp className="text-lg" />
                    <span>Message us</span>
                  </a>
                )}
              </div>
            </div>
          ))}
          {isTyping && (
            <div className="bela-msg-row bot">
              <div className="bela-msg-avatar">
                <img src="/Bela.png" alt="" width={32} height={32} />
              </div>
              <div className="bela-msg-bubble bot">
                <div className="bela-typing" aria-label="Bela is typing">
                  <span />
                  <span />
                  <span />
                </div>
              </div>
            </div>
          )}
          <div ref={chatEndRef} />
        </div>

        <small className="bela-chatbot-powered">Powered by Belsoft Systems</small>

        <div className="bela-chatbot-footer">
          <form
            className="bela-chatbot-form"
            onSubmit={(e) => {
              e.preventDefault();
              sendMessage();
            }}
          >
            <input
              type="text"
              className="bela-chatbot-input"
              placeholder="Type your message..."
              value={input}
              onChange={(e) => setInput(e.target.value)}
              aria-label="Type your message"
            />
            <button
              type="submit"
              className="bela-chatbot-send"
              title="Send"
              aria-label="Send message"
            >
              <FaPaperPlane size={14} />
            </button>
          </form>
        </div>
      </div>
    </>
  );
}
